module.exports = __webpack_public_path__ + "static/img/print-solid.1670e0b0.png";